import React from "react";

import { Container, StyledFillEmailIcon } from "./styles";

type Props = {
  children: React.ReactNode;
};

export const HomepageThemeButtonDisplay: React.FunctionComponent<Props> = ({ children }) => (
  <Container>
    <StyledFillEmailIcon />
    {children}
  </Container>
);

HomepageThemeButtonDisplay.displayName = "HomepageThemeButtonDisplay";
